import { withPageUrlCheck } from 'hocs';
import type { FC } from 'react';

export const PageUrlCheckedRoute = ({ component }: Record<string, FC>) => {
  const Component = withPageUrlCheck(component);
  return <Component />;
};
